module.exports = __webpack_public_path__ + "img/5w2.11e74ee7.jpg";